module.exports = __webpack_public_path__ + "static/media/elrica_mrochen.2b0969a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/mitarbeiter/elrica_mrochen.jpg
// module id = 437
// module chunks = 0